<script>
import { computed, defineComponent } from "vue";

export default {
  name: "WinLayoutManager",
  props: {
    template: { type: String, default: "dialog" },
    
  },
  setup(props) {
    /**
     *  This is a computed property that will return the name
     *  of the current route
     */
    const layout = computed(() => {
      const layout = props.template;

      if (layout) {
        return `Win${layout}Layout`;
      }
      return null;
    });
    return {
      layout,
    };
  },
};
</script>

<template>
  aaaa -- {{ layout }}
  {{ props }}
  <component :is="layout">
    <slot></slot>
  </component>
</template>
